"use client";
import { ReactNode, useMemo } from "react";
import { usePathname } from "next/navigation";

export default function PageTransition({ children }: { children: ReactNode }) {
  const pathname = usePathname();

  // Check if current route is a dashboard route
  const isDashboardRoute = useMemo(() => {
    return pathname?.includes("/dashboard") || pathname === "/dashboard-unified";
  }, [pathname]);

  // Determine background class based on route
  const backgroundClass = useMemo(() => {
    return isDashboardRoute ? "bg-card-50" : "bg-card";
  }, [isDashboardRoute]);

  // Use inline style to ensure CSS variable is applied correctly
  // The CSS variable already contains the full oklch() value, so use it directly
  const backgroundStyle = useMemo(() => {
    return isDashboardRoute ? { backgroundColor: "var(--card-50)" } : undefined;
  }, [isDashboardRoute]);

  return (
    <main
      key={pathname}
      className={`${backgroundClass} animate-in fade-in slide-in-from-bottom-4 duration-300 flex-1 min-h-0`}
      style={backgroundStyle}
    >
      {children}
    </main>
  );
}
